/* eslint-disable import/no-cycle */
import { Tooltip } from 'crux';
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { ReviewLabel } from '../Components/UIElements';
import TextElement from '../Components/UIElements/TextElement';
import Table from '../Components/UIElements/Table';
import Separator from '../Components/UIElements/Separator';
import ImageText from '../Components/UIElements/ImageText';
import Input from '../cruxComponents/Input';
import Button from '../cruxComponents/Button';
import MultiSelect from '../cruxComponents/MultiSelect';
import SingleSelect from '../cruxComponents/SingleSelect';
import SelectOption from '../cruxComponents/SelectOption';
import DatePicker from '../cruxComponents/DatePicker';
import { InputWrapper } from '../cruxComponents/utils/styles';
import Modal from '../Components/UIElements/Modal';
import Tabs from '../Components/UIElements/Tabs';
import DataSelector from '../cruxComponents/DataSelector';
import VideoEmbedder from '../Components/UIElements/VideoEmbedder';
import GroupQuestionText from '../Components/UIElements/TextElement/GroupQuestionText';
import { getPopupQuestions } from '../redux/selector/validations';
import { setPopupDetails } from '../redux/actions/questions';
import { getTooltipProps } from '../cruxComponents/utils';
import { getPopupDetails, retry } from '../utils';
import CardpointePaymentModal from '../Components/CardpointePaymentModal/CardpointePaymentModal';

const PdfLazy = React.lazy(() => retry(() => import('../Components/UIElements/Pdf')));

const TooltipWrapper = styled.div`
  display: flex;
  justify-content: ${({ pageProps }) => pageProps && pageProps.compareQuotePosition};
`;
const TooltipIcon = styled.div`
  margin: 5px 10px;
`;

/**
 * @description create an extra layer of div to add (if needed) any attribute
 * to any of the form elements. The reason of creating this wrapper is to have
 * a parent element which can take care of all the instances of execution of
 * GetElementFunc.
 */
const getElement = ({
  questionObj,
  sectionIndex,
  isEditMode = false,
  listParentId = '',
  listIndex = null,
  popupQuestions,
  updatePopupDetails,
  isNestedQ = false,
  parentListIndex = null,
  theme,
  addressRoute = [],
  addressFieldsMappingData = [],
  stateMappingData = [],
}) => {
  const handlePopup = (e) => {
    // the preventDefault will prevent toggling of checkbox when label is clicked
    e.preventDefault();
    if (popupQuestions && updatePopupDetails) {
      const newPopupDetails = getPopupDetails(questionObj, popupQuestions);
      updatePopupDetails(newPopupDetails);
    }
  };
  const presentationType = questionObj.presentation_type
    ? questionObj.presentation_type
    : 'questions';
  const {
    display_type: displayType,
    hint_title: tooltipTitle,
    hint_text: tooltipBody,
    hint_html: tooltipHTML,
    tooltip,
    validations,
  } = questionObj;
  const tooltipProps = getTooltipProps(tooltipTitle, tooltipBody, tooltipHTML || tooltip);
  const {
    screenViewport,
    pageId,
    config: {
      theme: { pageOverrides },
    },
  } = theme;

  // Accessibility Labels
  const { hasOptionalLabel, optionalText } = get(theme, 'config.features.a11y', {
    hasOptionalLabel: false,
    optionalText: '',
  });
  const convertToDropdown = get(theme, 'config.theme.components.radio.convertToDropdown', false);
  const hideTooltipWrapper = get(pageOverrides, [pageId, 'hideTooltipWrapper'], false);
  let optionalvalue = '';
  if (hasOptionalLabel) {
    const isRequired = get(validations, 'required.value', false);
    optionalvalue = isRequired ? '' : optionalText;
  }
  const tooltipColor = get(theme, 'config.theme.global.toolTip.color', '');
  const tooltipFont = get(theme, 'config.theme.global.toolTip.font', '');

  const pageProps = pageOverrides[pageId];
  // Google Autocomplete
  const shoulAddressPrefill = !!addressRoute.filter((route) => route === questionObj.question_id);
  let addressPrefillQuestions = [];
  let statePrefillData = [];

  if (shoulAddressPrefill) {
    addressPrefillQuestions = addressFieldsMappingData[questionObj.question_id] || null;
    statePrefillData = stateMappingData;
  }
  if (presentationType === 'review' || displayType === 'html') {
    return (
      <ReviewLabel
        questionObj={ questionObj }
        key={ questionObj.question_id }
        handleLabelChange={ () => {} }
        tooltipProps={ tooltipProps }
        addressPrefillQuestions={ addressPrefillQuestions }
      />
    );
  }

  const commonProps = {
    isNestedQ,
    parentListIndex,
  };

  switch (questionObj.question_type) {
    case 'text':
    case 'password':
    case 'number':
    case 'text_area':
      return (
        <Input
          question={ questionObj }
          optionalText={ optionalvalue }
          key={ questionObj.question_id }
          sectionIndex={ sectionIndex }
          isEditMode={ isEditMode }
          listParentId={ listParentId }
          listIndex={ listIndex }
          addressPrefillQuestions={ addressPrefillQuestions }
          statePrefillData={ statePrefillData }
          type='M'
          { ...commonProps }
        />
      );
    case 'date':
      return (
        <InputWrapper
          name='input-wrapper'
          questionId={ questionObj.question_id }
          device={ screenViewport }
          inputType='dateInput'
        >
          <DatePicker
            question={ questionObj }
            optionalText={ optionalvalue }
            key={ questionObj.question_id }
            sectionIndex={ sectionIndex }
            isEditMode={ isEditMode }
            listParentId={ listParentId }
            listIndex={ listIndex }
            addressPrefillQuestions={ addressPrefillQuestions }
            { ...commonProps }
          />
        </InputWrapper>
      );
    case 'button':
      return (
        <Button question={ questionObj } key={ questionObj.question_id } sectionIndex={ sectionIndex } />
      );
    case 'video':
      return (
        <VideoEmbedder questionText={ questionObj.question_text } videoUrl={ questionObj.video_url } />
      );
    case 'singleselection':
      // if the number of options are greater than 3 , we will go with displaying dropdown in screenviewport mobile
      if (
        !(
          convertToDropdown &&
          questionObj.response_options.length > 3 &&
          screenViewport === 'mobile' &&
          questionObj.display_type !== 'cards'
        ) &&
        ((questionObj.display_type && questionObj.display_type === 'radio') ||
          questionObj.display_type === 'radio_button' ||
          questionObj.display_type === 'cards' ||
          questionObj.display_type === 'default_radio' ||
          questionObj.display_type === 'product_card')
      ) {
        return (
          <SingleSelect
            question={ questionObj }
            optionalText={ optionalvalue }
            key={ questionObj.id }
            sectionIndex={ sectionIndex }
            isEditMode={ isEditMode }
            listParentId={ listParentId }
            listIndex={ listIndex }
            { ...commonProps }
          />
        );
      }
      if (questionObj.display_type && questionObj.display_type === 'data_selector') {
        return <DataSelector question={ questionObj } sectionIndex={ sectionIndex } />;
      }
      if (questionObj.display_type && questionObj.display_type === 'modal') {
        return (
          <Modal
            key={ questionObj.question_id }
            questionObj={ questionObj }
            response={ questionObj.response }
            sectionIndex={ sectionIndex }
            { ...commonProps }
          />
        );
      }
      return (
        <SelectOption
          question={ questionObj }
          key={ questionObj.question_id }
          sectionIndex={ sectionIndex }
          isEditMode={ isEditMode }
          listParentId={ listParentId }
          listIndex={ listIndex }
          type='D'
          { ...commonProps }
        />
      );
    case 'modal':
      if (questionObj.display_type === 'cardpointe-modal') {
        return (
          <CardpointePaymentModal
            key={ questionObj.question_id }
            questionObj={ questionObj }
            response={ questionObj.response }
            sectionIndex={ sectionIndex }
          />
        );
      }
      return (
        <Modal
          key={ questionObj.question_id }
          questionObj={ questionObj }
          response={ questionObj.response }
          sectionIndex={ sectionIndex }
          { ...commonProps }
        />
      );
    case 'multiselection':
      if (questionObj.display_type === 'checkbox') {
        return (
          <MultiSelect
            question={ questionObj }
            isEditMode={ isEditMode }
            sectionIndex={ sectionIndex }
            handlePopup={ handlePopup }
            listIndex={ listIndex }
            { ...commonProps }
          />
        );
      }
      return (
        <SelectOption
          question={ questionObj }
          key={ questionObj.question_id }
          sectionIndex={ sectionIndex }
          isEditMode={ isEditMode }
          listParentId={ listParentId }
          listIndex={ listIndex }
          type='M'
          { ...commonProps }
        />
      );
    case 'autocomplete-text':
      return (
        <SelectOption
          question={ questionObj }
          key={ questionObj.question_id }
          sectionIndex={ sectionIndex }
          addressPrefillQuestions={ addressPrefillQuestions }
          type='A'
          { ...commonProps }
        />
      );
    case 'document':
      return (
        <React.Suspense fallback={ <div>Loading...</div> }>
          <PdfLazy
            question={ questionObj }
            key={ questionObj.question_id }
            sectionIndex={ sectionIndex }
            { ...commonProps }
          />
        </React.Suspense>
      );
    case 'popup':
      if (questionObj.display_type === 'table') {
        return <Table question={ questionObj } key={ questionObj.question_id } { ...commonProps } />;
      }
      return null;
    case 'group':
      if (hideTooltipWrapper) {
        return <GroupQuestionText key={ questionObj.question_id } questionObj={ questionObj } />;
      }
      return (
        <TooltipWrapper pageProps={ pageProps }>
          <GroupQuestionText
            key={ questionObj.question_id }
            questionObj={ questionObj }
            handlePopup={ handlePopup }
          />
          {tooltipProps.hasTooltip && (
            <TooltipIcon>
              <Tooltip
                ariaLabel={ `${questionObj.question_text} info dialog` }
                removeAriaLabelforPopper
                name='tool-tip'
                color={ tooltipColor }
                themeConfiguration={ { tooltipFont, tooltipTextColor: tooltipColor } }
                { ...tooltipProps }
              />
            </TooltipIcon>
          )}
        </TooltipWrapper>
      );

    case 'separator':
      return <Separator key={ questionObj.question_id } questionObj={ questionObj } />;
    case 'image_text':
      return <ImageText key={ questionObj.question_id } questionObj={ questionObj } />;
    case 'tabs':
      if (questionObj.display_type === 'tabs') {
        return (
          <Tabs
            key={ questionObj.question_id }
            question={ questionObj }
            sectionIndex={ sectionIndex }
            { ...commonProps }
          />
        );
      }
      return null;
    case 'label':
    default:
      return (
        <TooltipWrapper pageProps={ pageProps }>
          <TextElement
            key={ questionObj.question_id }
            id={ `${questionObj.question_id}-${questionObj.question_type}-${questionObj.display_type}-label` }
            styleType={ questionObj.presentation_type || questionObj.display_type }
            text={ questionObj.question_text }
            questionObj={ questionObj }
            sectionIndex={ sectionIndex }
            handlePopup={ handlePopup }
            screenViewport={ screenViewport }
          />
          {tooltipProps.hasTooltip && (
            <TooltipIcon>
              <Tooltip
                ariaLabel={ `${questionObj.question_text} info dialog` }
                removeAriaLabelforPopper
                name='tool-tip'
                color={ tooltipColor }
                themeConfiguration={ { tooltipFont, tooltipTextColor: tooltipColor } }
                { ...tooltipProps }
              />
            </TooltipIcon>
          )}
        </TooltipWrapper>
      );
  }
};

const GetElementWrapper = styled.div`
  @media (max-width: 480px) {
    width: 100%;
    max-width: 360px;
    max-width: ${({ pageId, questionType }) =>
      pageId === 'signature' && questionType === 'text' ? '360px' : '100%'};
  }
`;

const GetElementFunc = (props) => {
  const klass = get(props, 'questionObj.className', '');
  const questionType = get(props, 'questionObj.question_type');
  const displayType = get(props, 'questionObj.display_type');
  const questionId = get(props, 'questionObj.question_id');
  const pageId = get(props, 'theme.pageId');

  return (
    <GetElementWrapper
      data-name='get-element-wrapper'
      id={ `${questionType}-${displayType}-wrapper-${questionId}` }
      className={ klass }
      questionType={ questionType }
      pageId={ pageId }
    >
      {getElement(props)}
    </GetElementWrapper>
  );
};

const mapStateToProps = (state) => {
  const popupQuestions = getPopupQuestions(state);
  const addressRoute = get(state, 'questions.addressRoute', []);
  const addressFieldsMappingData = get(state, 'questions.addressFieldsMappingData', []);
  const stateMappingData = get(state, 'questions.stateMappingData', []);
  return {
    popupQuestions,
    addressRoute,
    addressFieldsMappingData,
    stateMappingData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePopupDetails: (payload) => {
      dispatch(setPopupDetails(payload));
    },
  };
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(GetElementFunc));
